import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authMfaRoute } from '#/modules/auth/routing/auth.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { MfaPageLoadable } from './MfaPageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof authMfaRoute>,
) {
  await MfaPageLoadable.load();
}

export default function AuthMfaHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Multi Factor Authentication')}>
      <MfaPageLoadable />
    </RouteModule>
  );
}
